import React, { useEffect, useState } from 'react'
import { MDBInput } from 'mdbreact';
import axios from 'axios'
import useTraeDatos from '../hooks/useTraeDatos';
import { traeIdNombre, existeRegistro, recibeImagen, errores } from '../hooks/Funciones'
import fotoVacia from '../../paginas/img/fotoVacia.jpg'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SubirEditItemsAdmin = ({ baseUrl, data, setData, setFuncion, urlIngresos, registroSelect, TituloBtn, funcion }) => {

	const [registro, setRegistro] = useState(funcion === 'editar' ? registroSelect : { activo: true, ids_tipoingresos: [], imagePrev: fotoVacia })
	const [error, setError] = useState({ activo: false })

	//Consulta para subir o crear los datos 

	const creaFormData = (registro, METHOD) => {

		let { id, nombre, icono, descripcion, color } = registro

		let f = new FormData()
		if (funcion === 'editar') { f.append('id', id) }
		f.append('nombre', nombre)
		f.append('icono', icono)
		f.append('descripcion', descripcion)
		f.append('color', color)
		f.append('METHOD', METHOD)
		return f
	}

	const peticionPost = async () => {

		let { nombre, icono, descripcion, color } = registro

		if (!existeRegistro(data, nombre)) {
			if (nombre !== undefined && icono !== undefined && descripcion !== undefined && color !== undefined) {

				let f = creaFormData(registro, 'POST')
				await axios.post(baseUrl, f)

					.then(response => {
						console.log('result', response.data)
						let resultFormat = { ...response.data }
						setData([resultFormat, ...data])
						setRegistro({ activo: false })
						errores('Limpio', setError)
						setFuncion('ver')

					}).catch(error => {
						console.log(error);
					})
			} else errores('CampoVacio', setError)
		} else errores('Existe', setError)

	}

	const ProcedimientoPut = async () => {

		let { id, nombre, icono, descripcion, color } = registro

		let f = creaFormData(registro, 'PUT')
		await axios.post(baseUrl, f)

			.then(response => {

				console.log(response.data)
				let dataNueva = data
				dataNueva.map(item => {
					if (item.id === id) {
						item.nombre = nombre
						item.icono = icono
						item.descripcion = descripcion
						item.color = color
					}
				})
				setData(dataNueva)
				console.log('enviado')
				errores('Limpio', setError)
			}).catch(error => {
				console.log('muestra erro: ' + error);
			})
		setFuncion('ver')
	}

	const peticionPut = () => {
		let { id, nombre, icono, descripcion, color } = registro
		if (nombre !== '' && icono !== '' && descripcion !== '' && color !== '') {
			ProcedimientoPut()
		} else errores('CampoVacio', setError)
	}


	return (
		<div>
			<div className="row">
				<div className="col-md-12">
					{error.activo ? <span className="error"> Error: {error.mensaje}</span> : null}
					<div><hr />

						<div className='row'>
							<div className='col-md-8'>
								<p>Para subir un icono seleccion uno de la Librería fontawesome5 de esta página: <a href='https://icons.expo.fyi/'>https://icons.expo.fyi/</a></p>
								<MDBInput
									label="Nombre de Nivel" name="nombre" required className={error.nombre ? "form-control is-invalid" : null} outline
									value={registro.nombre}
									onChange={e => setRegistro({ ...registro, nombre: e.target.value })}
								/>
								<MDBInput
									label="Descripcion" name="descripcion" required className={error.descripcion ? "form-control is-invalid" : null} outline
									value={registro.descripcion}
									onChange={e => setRegistro({ ...registro, descripcion: e.target.value })}
								/>
								<MDBInput
									label="Código Icono" name="icono" required className={error.icono ? "form-control is-invalid" : null} outline
									value={registro.icono}
									onChange={e => setRegistro({ ...registro, icono: e.target.value })}
								/>
								<MDBInput
									label="Código Color" name="color" required className={error.color ? "form-control is-invalid" : null} outline
									value={registro.color}
									onChange={e => setRegistro({ ...registro, color: e.target.value })}
								/>

							</div>
						</div>

						<br />
						<div className="col text-center">
							<button onClick={funcion === 'editar' ? peticionPut : peticionPost} className="btn boton_estandar">{TituloBtn} </button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default SubirEditItemsAdmin